// Components
import { CheckboxesContainer } from 'app/shared/modules/hdp/form/Contact/ContactSimilarListingsV2/ContactSimilarListingsCheckboxWrapperStyles';
import * as S from 'app/shared/modules/hdp/form/Contact/ContactSimilarListingsV2/styles';

import type { SimilarListingDetails } from 'app/types/similarListingDetails.type';

import { useYieldCallback } from '@zillow/yield-callback';

interface ContactSimilarListingsCheckboxWrapperProps {
  listing: SimilarListingDetails;
  onClick: (listing: SimilarListingDetails, idx: number, action: string) => void;
  idx: number;
  isChecked: boolean;
  isDisabled: boolean;
}
const ContactSimilarListingsCheckboxWrapper = ({
  listing,
  onClick,
  idx,
  isChecked,
  isDisabled,
}: ContactSimilarListingsCheckboxWrapperProps) => {
  const handleCheckboxClick = useYieldCallback(() => {
    onClick(listing, idx, !isChecked ? 'add' : 'subtract');
  }, [isChecked, listing, idx, onClick]);

  const checkboxId = `contact-listing-checkbox-${idx}`;

  return (
    <CheckboxesContainer>
      <S.Checkbox
        type="checkbox"
        id={checkboxId}
        checked={isChecked}
        onChange={handleCheckboxClick}
        disabled={isDisabled}
        aria-label={`Select ${listing.displayName} for messaging`}
      />
      <S.Label htmlFor={checkboxId}>Select</S.Label>
    </CheckboxesContainer>
  );
};

export default ContactSimilarListingsCheckboxWrapper;
